import { Component, ChangeDetectionStrategy } from '@angular/core';
import { SvgIconComponent } from '../shared/icons/svg-icon.component';
import { ChangeLogSearchComponent } from '../shared/change-log/change-log-search/change-log-search.component';
import { ChangeLogViewerComponent } from '../shared/change-log/change-log-viewer/change-log-viewer.component';

@Component({
    selector: 'app-change-log',
    templateUrl: './change-log.component.html',
    styleUrls: ['./change-log.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent, ChangeLogSearchComponent, ChangeLogViewerComponent]
})
export class ChangeLogComponent {
}
